<template>
  <div class="container">
     <div class="row crossword-header">
        <div class="col-md-12 mt-3">
           <div class="d-flex align-items-center justify-content-between mt-1">
              <p class="color text-uppercase mb-0">
                 <span><a href="/">Crossword Race</a></span>
                 <span class="mx-2">/</span>
                 <span><a href="/crossword/live">Live Arena</a></span>
              </p>
           </div>
           <li class="mb-0 col-12 mt-1" style="list-style-type: none;">
              <h1 class="mb-0">Live Crossword Arena</h1>
              <div class="mt-1">
                 <ul class="crossword-header-subtitle mb-0" v-if="!isWaitForJoin">
                    <li class="me-2">Lobby {{ roomId }}<i class="bi bi-arrow-clockwise ms-2" style="cursor: pointer; font-size: small;" @click="joinNewLobby"></i></li>
                    &#9675;
                    <li class="mx-2">
                       {{ playerCount }}
                       <span v-if="playerCount === 1">player</span>
                       <span v-else>players</span>
                    </li>
                 </ul>
                 <ul class="crossword-header-subtitle mb-0" v-else>
                    <li class="me-2">Searching for lobby...</li>
                 </ul>
              </div>
           </li>
        </div>
        <div class="col-md-12 mt-3">
           <div class="header-row top-search-parent">
              <div style="margin-right: auto;" class="d-flex">
                 <span>
                    <RaceTimer ref="puzzleTimer" />
                 </span>
              </div>
              <div class="header-misc ms-0">
                 <div class="header-misc-icon">
                    <ul class="crossword-header-subtitle mb-0">
                       <li class="forum-home-toolbar">
                          <label for="roomIdSelect" class="visually-hidden">Select Room Mode</label>
                          <select
                             class="form-select custom-select-dropdown"
                             id="roomIdSelect"
                             v-model="roomPuzzlePreferences"
                             @change="changeRoomPuzzlePreferences"
                             >
                             <option :value="roomPuzzlePreferencesEnum.AI_PUZZLES">A.I. Puzzles</option>
                             <option :value="roomPuzzlePreferencesEnum.COMMUNITY_PUZZLES">Community Puzzles</option>
                          </select>
                       </li>
                    </ul>
                 </div>
                 <div class="header-misc-icon">
                    <a
                       href="#"
                       data-bs-toggle="modal"
                       data-bs-target="#crosswordSettingsModal"
                       >
                    <i class="bi bi-gear"></i>
                    </a>
                 </div>
                 <div class="header-misc-icon">
                    <a href="#" id="menuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class=""><i class="bi bi-pencil-square"></i></a>
                    <div class="dropdown-menu dropdown-menu-links rounded shadow-sm dropdown-menu-end py-0 m-0" aria-labelledby="menuLink" style="">
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="showRevealModal"
                          :class="{ 'disabled': !crossword || isPuzzleLocked }"
                          >
                       <i class="bi bi-pencil me-2"></i>Reveal Puzzle
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="revealSquare"
                          :class="{ 'disabled': !crossword || isPuzzleLocked }"
                          >
                       <i class="bi bi-pencil-fill me-2"></i>Reveal Square
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="checkPuzzle"
                          :class="{ 'disabled': !crossword || isPuzzleLocked }"
                          >
                       <i class="bi bi-check-circle me-2"></i>Check Puzzle
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="checkSquare"
                          :class="{ 'disabled': !crossword || isPuzzleLocked }"
                          >
                       <i class="bi bi-check-circle-fill me-2"></i>Check Square
                       </a>
                    </div>
                 </div>
                 <div class="header-misc-icon">
                    <a href="/post/How%20to%20Play" target="_blank">
                    <i class="bi-question-circle"></i>
                    </a>
                 </div>
                 <div class="header-misc-icon">
                    <a href="#" id="menuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class=""><i class="bi bi-three-dots"></i></a>
                    <div class="dropdown-menu dropdown-menu-links rounded shadow-sm dropdown-menu-end py-0 m-0" aria-labelledby="menuLink" style="">
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="resetPuzzle"
                          >
                       <i class="bi-x-circle me-2"></i>Reset Grid
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="createNewLobby"
                          >
                       <i class="bi bi-plus-square me-2"></i>Create Lobby
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="copyLobbyLink"
                          >
                       <i class="bi bi-copy me-2"></i>Copy Lobby Link
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          @click="flagContent('CrosswordRace')"
                          >
                       <i class="bi-flag me-2"></i>Flag Content
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          v-if="!isShowVirtualKeyboard()"
                          @click="toggleShowVirtualKeyboard(true)"
                          >
                       <i class="bi bi-keyboard me-2"></i>Enable Virtual Keyboard
                       </a>
                       <a
                          class="dropdown-item"
                          href="#"
                          v-if="isShowVirtualKeyboard()"
                          @click="toggleShowVirtualKeyboard(false)"
                          >
                       <i class="bi bi-keyboard me-2"></i>Disable Virtual Keyboard
                       </a>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
     <div class="row">
        <div class="col-lg-8">
           <div class="puzzle-overlay" v-if="showPuzzleOverlay && !showActivityWarning">
              <div class="sale-flash" style="left: 0 !important; width: 100% !important">
                 <div class="badge bg-color rounded-0 fw-normal p-2" style="width: 100% !important;">
                    <h3 class="fs-2 my-3 fw-medium px-lg-5 text-pop-image-text" v-if="gameStatus === raceStatusEnum.JOINING">
                       <div class="loading-text">
                          Joining a lobby<span class="dots">
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                          </span>
                       </div>
                    </h3>
                    <h3 class="fs-2 my-3 fw-medium px-lg-5 text-pop-image-text mb-2" v-if="gameStatus === raceStatusEnum.COUNTDOWN">
                       Next game starting in {{ countdown }}
                    </h3>
                    <h3 class="fs-2 my-3 fw-medium px-lg-5 text-pop-image-text" v-if="gameStatus === raceStatusEnum.WAITING">
                       <div class="loading-text">
                          Waiting for round to end<span class="dots">
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                          </span>
                       </div>
                    </h3>
                    <h3 class="fs-2 my-3 fw-medium px-lg-5 text-pop-image-text" v-if="gameStatus === raceStatusEnum.SOLVED">
                       Completed in {{ this.getTime() }}
                    </h3>
                    <h3 class="fs-2 my-3 fw-medium px-lg-5 text-pop-image-text" v-if="gameStatus === raceStatusEnum.REVEALED">
                       Puzzle Revealed
                    </h3>
                    <div class="lh-sm small my-3 op-06 px-lg-5" style="white-space: normal;" v-if="!isLoggedIn">
                       You’re playing as {{ username }}. <a style="text-decoration: underline !important; color: white; text-underline-offset: 2.5px !important; cursor: pointer;" href="/signIn">Create an account</a> to save your progress and join the leaderboard!
                    </div>
                    <div class="lh-sm small my-3 op-06 px-lg-5" style="white-space: normal;" v-else>
                       You’re playing as {{ username }}. Want to see how you stack up against other players? Check out the <a style="text-decoration: underline !important; color: white; text-underline-offset: 2.5px !important; cursor: pointer;" href="/crossword/leaderboard">leaderboard!</a>
                    </div>
                    <div class="lh-sm small my-3 op-06 px-lg-5" style="white-space: normal;" v-if="gameStatus === raceStatusEnum.WAITING || gameStatus === raceStatusEnum.SOLVED || gameStatus === raceStatusEnum.REVEALED">
                       <div style="white-space: normal;">
                          Don't want to wait? <a style="text-decoration: underline !important; color: white; text-underline-offset: 2.5px !important; cursor: pointer;" @click="joinNewLobby">Create a new lobby.</a>
                       </div>
                    </div>
                    <div class="my-3 px-lg-5" v-if="gameStatus === raceStatusEnum.REVEALED">
                       <RevealedPuzzle :crossword="crossword" />
                    </div>
                 </div>
                 <div v-if="raceResults != null && this.gameStatus === raceStatusEnum.SOLVED" class="race-result-container mt-3">
                    <RaceResult :raceResults="raceResults" />
                 </div>
                 <div v-if="finalRaceResults != null && this.gameStatus === raceStatusEnum.COUNTDOWN" class="race-result-container mt-3">
                    <FinalRaceResult :raceResults="finalRaceResults" />
                 </div>
              </div>
           </div>
           <div class="puzzle-overlay" v-if="showActivityWarning">
              <div class="sale-flash" style="left: 0 !important; width: 100% !important">
                 <div class="badge bg-color rounded-0 fw-normal p-2" style="width: 100% !important;">
                    <h3 class="fs-2 my-3 fw-medium px-lg-5 text-pop-image-text mb-2">
                       Are you still there? 
                    </h3>
                    <div class="lh-sm small my-3 op-06 px-lg-5" style="white-space: normal;">
                       Move mouse or click to return to puzzle.  Otherwise, you will be redirected shortly.
                    </div>
                 </div>
              </div>
           </div>
           <Puzzle :crossword="crossword" :isPuzzleLocked="isPuzzleLocked" ref="puzzle" />
        </div>
        <div class="col-lg-4" id="crossword-race-box">
           <PuzzleGhost :crossword="crossword" :socket="socket" :messages="gameMessages" />
        </div>
     </div>
     <div class="row">
        <div class="col-12 col-lg-4 ms-auto" v-if="!isApiCallInProgress">
           <Chat :socket="socket" :messages="lobbyMessages" />
        </div>
     </div>
     <div class="container mt-5">
        <div class="row gx-5 col-mb-50">
           <div class="col-lg-8 col-xl-8 portfolio-single-content px-5 ps-xl-5 pt-xl-4">
              <h3 class="fs-3 fw-bold">About Crossword Race</h3>
              <p>
                 Welcome to the Live Crossword Arena, where players from around the world come together to solve puzzles in real time.
                 Compete against others, sharpen your skills, and see how fast you can solve the puzzle. Whether you're a
                 casual solver or a crossword enthusiast, there's always a game waiting for you. 
              </p>
              <a href="/post/How%20to%20Play" target="_blank" class="button button-border button-dark rounded-pill ms-0">How To Play<i class="bi-arrow-right ms-2"></i></a>
              <div class="row g-4 mt-4">
                 <div class="col-6">
                    <h5 class="mb-2">Share</h5>
                    <div>
                       <a :href="facebookShareLink" class="social-icon si-small text-white border-transparent rounded-circle bg-facebook" title="Facebook">
                       <i class="fa-brands fa-facebook-f"></i>
                       <i class="fa-brands fa-facebook-f"></i>
                       </a>
                       <a :href="twitterShareLink" class="social-icon si-small text-white border-transparent rounded-circle bg-x-twitter" title="Twitter">
                       <i class="fa-brands fa-x-twitter"></i>
                       <i class="fa-brands fa-x-twitter"></i>
                       </a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-4 col-xl-4 portfolio-single-image">
              <img
                 src="/demos/mj/cc_players.png"
                 style="max-height: 300px; object-fit: contain;"
                 loading="lazy"
                 >
           </div>
        </div>
     </div>
  </div>
  <div class="section bg-transparent my-0 py-0">
     <div class="container-fluid py-6">
        <div class="row justify-content-center mx-auto mw-md gx-5">
           <div class="col">
              <p class="h6 mb-0">
                 We pride ourselves on maintaining a positive, friendly community atmosphere, so let's keep it fun and fair for everyone. 
                 If you encounter any bugs, or notice any players who aren't being good sports, using inappropriate language, or
                 cheating, please let us know. We also appreciate feedback on any weird or questionable clues — your input helps
                 us improve the experience. Need to get in touch? <a href="/about#contact">Contact Us</a>
              </p>
           </div>
        </div>
     </div>
  </div>
  <div class="modal fade" id="crosswordSettingsModal" tabindex="-1" aria-labelledby="crosswordSettingsModalLabel" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
           <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
           </div>
           <div class="modal-body">
              <div class="row p-4 bg-white d-flex align-items-center justify-content-center rounded">
                 <div class="col-12 p-4">
                    <h3 class="mb-2">Crossword Settings</h3>
                    <div class="row mb-3 align-items-center">
                       <label class="col-10 col-sm-10" for="basic-url">
                          <h4 class="mb-1 d-block fw-medium fs-6">Letter Input</h4>
                          <p class="text-contrast-600 mb-0">
                             When toggled, skip over filled letters while entering a clue.  Otherwise, you 
                             will re-enter letters to fill out a clue.
                          </p>
                       </label>
                       <div class="col-2 col-sm-2 d-flex justify-content-end">
                          <div class="form-check form-switch">
                             <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                v-model="crosswordSettings.skipFilledLetters"
                                @change="updateSkipFilledLettersSetting"
                                />
                          </div>
                       </div>
                    </div>
                    <div class="row mb-3 align-items-center">
                       <label class="col-10 col-sm-10" for="basic-url">
                          <h4 class="mb-1 d-block fw-medium fs-6">Clue Completion</h4>
                          <p class="text-contrast-600 mb-0">
                             When toggled, you will automatically move to the next clue. Otherwise, you
                             will stay on the previous clue.
                          </p>
                       </label>
                       <div class="col-2 col-sm-2 d-flex justify-content-end">
                          <div class="form-check form-switch">
                             <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                v-model="crosswordSettings.moveToNextClueAtEndOfWord"
                                @change="updateMoveToNextClueAtEndOfWordSetting"
                                />
                          </div>
                       </div>
                    </div>
                    <div class="row mb-5 align-items-center">
                       <label class="col-10 col-sm-10" for="basic-url">
                          <h4 class="mb-1 d-block fw-medium fs-6">Spacebar</h4>
                          <p class="text-contrast-600 mb-0">
                             When toggled, spacebar will toggle between across/down clues. Otherwise, spacebar
                             will move to the next clue.
                          </p>
                       </label>
                       <div class="col-2 col-sm-2 d-flex justify-content-end">
                          <div class="form-check form-switch">
                             <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                v-model="crosswordSettings.spaceToggleDirection"
                                @change="updateSpaceToggleDirectionSetting"
                                />
                          </div>
                       </div>
                    </div>
                    <button
                       type="button"
                       class="button button-large m-0 bg-color text-light h-op-08"
                       data-bs-dismiss="modal"
                       >
                    Close
                    </button>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  <div class="modal fade" id="createLobbyModalId" tabindex="-1" aria-labelledby="createLobbyModalLabel" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
           <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
           </div>
           <div class="modal-body">
              <div class="row p-4 bg-white d-flex align-items-center justify-content-center rounded">
                 <div class="col-md-12 p-4">
                    <h3 class="mb-2">
                       Create Lobby
                    </h3>
                    <div class="row mb-3 align-items-center">
                       <label class="col-10 col-sm-10" for="basic-url">
                          <h4 class="mb-1 d-block fw-medium fs-6">Puzzle Type</h4>
                          <p class="text-contrast-600 mb-0">
                             When toggled, puzzles in the Live Arena will be sourced from Community Puzzles created by site members. 
                             Otherwise, automatically generated puzzles will be used.
                          </p>
                       </label>
                       <div class="col-2 col-sm-2 d-flex justify-content-end">
                          <div class="form-check form-switch">
                             <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                v-model="createRoomCommunityMode"
                                />
                          </div>
                       </div>
                    </div>
                    <div class="row mb-3 align-items-center">
                       <label class="col-10 col-sm-10" for="basic-url">
                          <h4 class="mb-1 d-block fw-medium fs-6">Privacy</h4>
                          <p class="text-contrast-600 mb-0">
                             When enabled, only players with the share link can join. Otherwise, any player can join.
                          </p>
                       </label>
                       <div class="col-2 col-sm-2 d-flex justify-content-end">
                          <div class="form-check form-switch">
                             <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                v-model="createRoomPrivacyMode"
                                />
                          </div>
                       </div>
                    </div>
                    <button type="button" class="button button-large m-0 bg-color text-light h-op-08" @click="launchNewLobby" data-bs-dismiss="modal">Create</button>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  <div class="modal fade" id="changeRoomPuzzlePreferencesModalId" tabindex="-1" aria-labelledby="changeRoomPuzzlePreferencesModalLabel" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
           <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
           </div>
           <div class="modal-body">
              <div class="row p-4 bg-white d-flex align-items-center justify-content-center rounded">
                 <div class="col-md-12 p-4">
                    <h3 class="mb-2">
                       Change Room Preferences
                    </h3>
                    <p class="mb-4 fw-normal text-smaller text-black-50">
                       Updating your room preferences will require you to join a new lobby. Are you sure you want to continue?
                    </p>
                    <button type="button" class="button button-large m-0 bg-color text-light h-op-08" @click="confirmRoomPuzzlePreferences" data-bs-dismiss="modal">Confirm</button>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
  <div class="modal fade" id="revealPuzzleModalId" tabindex="-1" aria-labelledby="revealPuzzleModalLabel" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
           <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
           </div>
           <div class="modal-body">
              <div class="row p-4 bg-white d-flex align-items-center justify-content-center rounded">
                 <div class="col-md-12 p-4">
                    <h3 class="mb-2">
                       Confirm Reveal Puzzle
                    </h3>
                    <p class="mb-4 fw-normal text-smaller text-black-50">
                       Revealing the puzzle will forfeit the round. Are you sure you want to continue?
                    </p>
                    <button type="button" class="button button-large m-0 bg-color text-light h-op-08" @click="confirmRevealPuzzle" data-bs-dismiss="modal">Confirm</button>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import Puzzle from '@/components/crossword/Puzzle.vue'
import RaceTimer from '@/components/misc/RaceTimer.vue';
import PuzzleGhost from '@/components/crossword/PuzzleGhost.vue'
import RaceResult from '@/components/crossword/RaceResult.vue'
import FinalRaceResult from '@/components/crossword/FinalRaceResult.vue'
import Chat from '@/components/crossword/Chat.vue'
import { Crossword, CrosswordRaceResults, CrosswordRaceSolve, CrosswordSettings } from '@/models/Crossword';
import { disconnectSocket, GameMessage, initWebSocketConnection, isSocketOpen, LobbyMessage, parseWsMessage, sendSocketMessage } from '@/utils/ws';
import store, { DataStore, VuexModuleNamespaces } from '@/store';
import { getAnonymousUsername, getAnonymousUserId } from '@/utils/usernameTools';
import { getEpochSeconds } from '@/utils/time';
import { emitCrosswordKeyEvent, getCrosswordPuzzle } from '@/service/crosswords';
import { flagContent } from '@/utils/flag';
import { updateUser as refreshUser } from '@/utils/user';
import { adjustMobilePuzzleKeyboardPreferences, fetchMobilePuzzleKeyboardPreferences, isMobileUserAgent } from '@/service/mobile';
import { generateLobbyName, loadSettingsFromLocalStorage, PUZZLE_MODES, SAMPLE_MINI, loadRoomPuzzlePreferencesFromLocalStorage, saveRoomPuzzlePreferencesInLocalStorage, updateSettingsInLocalStorage } from '@/utils/crossword';
import RevealedPuzzle from '@/components/crossword/RevealedPuzzle.vue';
import { emitPrerenderEvent, setPageMetaTags } from '@/utils/seo';

// eslint-disable-next-line
const bootstrap = require("bootstrap");

enum RaceStatus {
  JOINING = "JOINING",
  IN_PROGRESS = "IN_PROGRESS",
  SOLVED = "SOLVED",
  WAITING = "WAITING",
  COUNTDOWN = "COUNTDOWN",
  REVEALED = "REVEALED",
  UNKNOWN = "UNKNOWN",
}

@Options({
  components: {
    Puzzle,
    PuzzleGhost,
    Chat,
    RaceTimer,
    RaceResult,
    FinalRaceResult,
    RevealedPuzzle,
  }
})
export default class CrosswordRace extends Vue {

  isApiCallInProgress = false;
  isWaitForNextRound = false;
  isNewToLobby = false;
  isWaitForJoin = true;
  isBroadcastInitialProgress = true;
  
  socket: WebSocket | null = null;
  websocketIntervalId = 0;
  lobbyMessages: LobbyMessage[] = [];
  gameMessages: GameMessage[] = [];
  crossword: Crossword = SAMPLE_MINI;
  crosswordSettings: CrosswordSettings = loadSettingsFromLocalStorage();

  raceStatusEnum = RaceStatus;
  roomPuzzlePreferencesEnum = PUZZLE_MODES;

  messageQueue: MessageEvent[] = [];
  processing = false;

  gameId = "";
  gameStartTime: number = getEpochSeconds();
  raceResults: CrosswordRaceResults | null = null;
  finalRaceResults: CrosswordRaceResults | null = null;

  countdown = 1000;

  inviteRoomId = "";
  createRoomCommunityMode = false;
  createRoomPrivacyMode = false;
  roomPuzzlePreferences = PUZZLE_MODES.COMMUNITY_PUZZLES;
  isRevealed = false;

  showActivityWarning = false;
  userActivityEvents = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'];
  inactivityTimer!: ReturnType<typeof setTimeout>;
  inactivityWarningTimer!: ReturnType<typeof setTimeout>;
  inactivityInterval!: ReturnType<typeof setInterval>;
  inactivityWarningInterval!: ReturnType<typeof setInterval>;
  superInactivityWarningInterval!: ReturnType<typeof setInterval>;


  public async mounted(): Promise<void> {
    try {
      // Set SEO meta tags
      setPageMetaTags(
          "Crossword Race - Multiplayer Live Arena",
          "Multiplayer live Crossword Arena. Compete against other players to solve 5x5 crosswords and climb the leaderboard.",
          null,
          window.location.href
      );

      // 🔔 Signal pre-render is ready
      emitPrerenderEvent();

      // Load content
      this.isApiCallInProgress = true;

      // Load puzzle preferences
      this.roomPuzzlePreferences = loadRoomPuzzlePreferencesFromLocalStorage();

      // Check if room in query params
      this.inviteRoomId = this.$route.query.inviteRoomId as string;

      // Enable the mobile keyboard if required
      if (isMobileUserAgent()) {
        adjustMobilePuzzleKeyboardPreferences(true);
      } else {
        adjustMobilePuzzleKeyboardPreferences(false);
      }

      // Refresh user info
      await refreshUser();
      
      // Init activity tracking
      this.setActivityTracking();

      // Initialize crossword and WebSocket connection
      this.socket = initWebSocketConnection(
        "wss://2esceokljk.execute-api.us-east-1.amazonaws.com/Prod/",
        this.userId,
        this.username,
        this.inviteRoomId,
        this.roomPuzzlePreferences.valueOf()
      );

      // Check socket connection
      setInterval(() => {
        if (!this.socket || !isSocketOpen(this.socket)) {
          window.location.href = '/'
        }
      }, 30000);

      // Start the countdown clock
      setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        }

        if (this.countdown === 0) {

          // Release lock for waiting
          this.isWaitForNextRound = false;
          this.isNewToLobby = false;

          // Start timer
          if (this.gameStatus == RaceStatus.IN_PROGRESS) {
            window.dispatchEvent(new MouseEvent('mousemove', { bubbles: true, cancelable: true }));
            this.raceResults = null;
            this.finalRaceResults = null;
            this.isRevealed = false;
            this.startTimer();
            this.emitPuzzleStartEvent();
          }

          // Decrement countdown
          this.countdown--;
        }
      }, 1000);

      // Listen for socket open
      this.socket.onopen = () => {
        if (this.socket) {
          // Broadcast initial progress and set timer
          this.broadcastProgress();
          this.websocketIntervalId = window.setInterval(this.broadcastProgress, 5000);
          this.websocketIntervalId = window.setInterval(this.broadcastGameReady, 2500);
          this.websocketIntervalId - window.setInterval(this.broadcastUnstuck, 10000);

          // Set new to lobby indicator
          this.isNewToLobby = true;
        }
      };

      // Listen for clock stop events
      window.addEventListener('xframe:finishCrossword', () => {
         this.stopTimer();
         this.broadcastGameEnd();
      }, false);

      // Listen for new socket and queue messages
      this.socket.onmessage = (event: MessageEvent) => this.queueMessage(event);
    } catch (err) {
      console.error("Error during WebSocket initialization:", err);
    } finally {
      this.isApiCallInProgress = false;
    }
  }

  setActivityTracking(): void {
      // Set activity timer
      const resetInactivityTimer = (): void => {
        clearInterval(this.inactivityInterval);
        this.inactivityInterval = setInterval(() => {
          if (this.gameStatus === RaceStatus.IN_PROGRESS && this.showActivityWarning) {
            window.location.href = '/';
          }
        }, 45000);
      };

      // Attach event listeners to reset the timer
      this.userActivityEvents.forEach((event) => {
        window.addEventListener(event, resetInactivityTimer);
      });

      // Initialize the timer on page load
      resetInactivityTimer();

      // Set activity warning timer
      const resetInactivityWarningTimer = (): void => {
        this.showActivityWarning = false;
        clearInterval(this.inactivityWarningInterval);
        this.inactivityWarningInterval = setInterval(() => {
          if (this.gameStatus === RaceStatus.IN_PROGRESS) {
            this.showActivityWarning = true;
          }
        }, 30000);
      };

      // Attach event listeners to reset the timer
      this.userActivityEvents.forEach((event) => {
        window.addEventListener(event, resetInactivityWarningTimer);
      });

      // Initialize the timer on page load
      resetInactivityWarningTimer();

      // Set activity warning timer
      const superInactivityWarningInterval = (): void => {
        this.showActivityWarning = false;
        clearInterval(this.superInactivityWarningInterval);
        this.superInactivityWarningInterval = setInterval(() => {
          this.showActivityWarning = true;
        }, 180000);
      };

      // Attach event listeners to reset the timer
      this.userActivityEvents.forEach((event) => {
        window.addEventListener(event, superInactivityWarningInterval);
      });

      // Initialize the timer on page load
      superInactivityWarningInterval();
  }

  beforeDestroy() {
    if (this.socket) {
      disconnectSocket(this.socket);
      window.clearInterval(this.websocketIntervalId);
      clearInterval(this.websocketIntervalId);
    }
  }

  initPuzzle(): void {
    try {
      (this.$refs.puzzle as Puzzle).initGrid();
    } catch (error) {
      console.log(error)
      // Ignore error
    }
  }

  resetPuzzle(): void {
    try {
      (this.$refs.puzzle as Puzzle).resetPuzzle();
    } catch (error) {
      // Ignore error
    }
  }

  revealGrid(): void {
    try {
      (this.$refs.puzzle as Puzzle).revealGrid();
    } catch (error) {
      // Ignore error
    }
  }

  resetTimer(): void {
    try {
      (this.$refs.puzzleTimer as RaceTimer).clearTimer();
    } catch (error) {
      // Ignore error
    }
  }

  startTimer(): void {
    (this.$refs.puzzleTimer as RaceTimer).startTimer();
  }

  stopTimer(): void {
    (this.$refs.puzzleTimer as RaceTimer).stopTimer();
  }

  getTime(): string {
    return (this.$refs.puzzleTimer as RaceTimer).formattedTime;
  }

  queueMessage(event: MessageEvent) {
    this.messageQueue.push(event);
    if (!this.processing) this.processQueue();
  }

  flagContent(content: string): void {
    flagContent(content);
  }

  updateSkipFilledLettersSetting(): void {
    const settings = loadSettingsFromLocalStorage();
    settings.skipFilledLetters = !settings.skipFilledLetters;
    updateSettingsInLocalStorage(settings);
    this.refreshCrosswordSettings();
  }

  updateMoveToNextClueAtEndOfWordSetting(): void {
    const settings = loadSettingsFromLocalStorage();
    settings.moveToNextClueAtEndOfWord = !settings.moveToNextClueAtEndOfWord;
    updateSettingsInLocalStorage(settings);
    this.refreshCrosswordSettings();
  }

  updateSpaceToggleDirectionSetting(): void {
    const settings = loadSettingsFromLocalStorage();
    settings.spaceToggleDirection = !settings.spaceToggleDirection;
    updateSettingsInLocalStorage(settings);
    this.refreshCrosswordSettings();
  }

  private async processQueue() {
    this.processing = true;
      while (this.messageQueue.length > 0) {
         const event = this.messageQueue.shift();
         if (event) {
            await this.processMessage(event);
         }
      }
      this.processing = false;
   }

  async processMessage(event: MessageEvent): Promise<void> {
    // Get lobby messages and game messages
    const [lobbyMessages, gameMessages] = parseWsMessage(event.data);
    if (lobbyMessages && lobbyMessages.length > 0) {
      this.lobbyMessages = [...lobbyMessages];
    }
    if (gameMessages && gameMessages.length > 0) {
      this.gameMessages = [...gameMessages];
    }

    // Set the game info
    const messageWithGame = this.lobbyMessages.find(
      (message) => message.action === 'game'
    );
    if (messageWithGame) {
      const newGameId = messageWithGame?.actionId ?? "";
      const gameStart = messageWithGame.data.gameStart ?? getEpochSeconds();
      const puzzleId = messageWithGame?.data.puzzleId ?? "";
      if (newGameId != this.gameId) {
        this.crossword = JSON.parse(await (await getCrosswordPuzzle(puzzleId)).data.data) as Crossword;
        this.gameId = newGameId;
        this.gameStartTime = gameStart;
        this.countdown = this.gameStartTime - getEpochSeconds();
        this.isWaitForJoin = false;
        this.isRevealed = false;
        this.resetTimer();
        this.resetPuzzle();
        this.initPuzzle();
      }
    }

    // Set game results if the game is over
    const messagesWithGameResult = this.lobbyMessages.filter(
      (message) => message.action === 'game_result'
    );
    for (const messageWithGameResult of messagesWithGameResult) {
      if (messageWithGameResult.actionId === this.gameId) {
        this.finalRaceResults = {
          results: this.parseGameMessages(gameMessages)
        }
      }
    }

    // Update race results if the game is ongoing
    this.raceResults = {
      results: this.parseGameMessages(gameMessages)
    };

    // Check if you joined an active lobby
    if (this.isNewToLobby && this.countdown < 0) {
      this.isWaitForNextRound = true;
    } else if (this.isNewToLobby && this.countdown > 0) {
      this.isWaitForNextRound = false;
    }

    // Check if we're picking up a state from a refresh page
    const reloadState = gameMessages.filter(message => message.userId === this.userId);
    if (this.isWaitForNextRound && reloadState.length == 1) {
      const state = JSON.parse(reloadState[0].state) as CrosswordRaceSolve
      if (!state.isWaiting) {
        this.isWaitForNextRound = false;
        this.isNewToLobby = false;
        // Reload from state
        this.reloadPuzzleFromState(state);
      }
    }

    // Broadcast initial progress
    if (this.isNewToLobby && this.isBroadcastInitialProgress) {
      this.broadcastGameReady();
      this.isBroadcastInitialProgress = false;
    }
  }

  broadcastProgress(): void {
    const crosswordState = this.crosswordRaceState;
    if (this.socket && crosswordState) {
      sendSocketMessage(this.socket, "game", JSON.stringify(crosswordState), this.userId, this.username);
    }
  }

  broadcastGameEnd(): void {
    const crosswordState = this.crosswordRaceState;
    if (this.socket && crosswordState) {
      sendSocketMessage(this.socket, "game", JSON.stringify(crosswordState), this.userId, this.username);
    }
  }

  broadcastGameReady(): void {
    if (this.socket && (this.gameStatus != RaceStatus.IN_PROGRESS && this.gameStatus != RaceStatus.COUNTDOWN)) {
      sendSocketMessage(this.socket, "game_ready", "", this.userId, this.username);
    }
  }

  broadcastUnstuck(): void {
    if (this.socket) {
    sendSocketMessage(this.socket, "game_ready", "", this.userId, this.username);
    }
  }

  parseGameMessages(gameMessages: GameMessage[]): CrosswordRaceSolve[] {
    return gameMessages.map(message => {
      const parsedState = JSON.parse(message.state) as CrosswordRaceSolve;
      return {
        ...parsedState,
        userDetails: message.userDetails,
      };
    });
  }

  reloadPuzzleFromState(state: CrosswordRaceSolve): void {
    try {
      this.isRevealed = false;
      this.initPuzzle();
      (this.$refs.puzzle as Puzzle).setGrid(state.state);
      (this.$refs.puzzleTimer as RaceTimer).setTimeFromString(state.time);
      this.startTimer();
    } catch (error) {
      // Ignore error
    }
  }

  emitPuzzleStartEvent(): void {
    const event = new Event('xframe:startCrossword', {
      cancelable: true
    });
    window.dispatchEvent(event);
  }

  toggleShowVirtualKeyboard(update: boolean): void {
    adjustMobilePuzzleKeyboardPreferences(update);
    if (update) {
      emitCrosswordKeyEvent("OPEN");
    } else {
      emitCrosswordKeyEvent("CLOSE");
    }
  }

  isShowVirtualKeyboard(): boolean {
    return fetchMobilePuzzleKeyboardPreferences();
  }

  joinNewLobby(): void {
    // Send lobby abandon message
    if (this.socket) {
      sendSocketMessage(this.socket, "lobby_abandon", "", this.userId, this.username);
    }
    // Refresh page
    window.location.href = "/crossword/live"
  }

  refreshCrosswordSettings(): void {
    this.crosswordSettings = loadSettingsFromLocalStorage();
  }

  copyLobbyLink(): void {
    const link = `https://crosswordrace.com/crossword/live?inviteRoomId=${this.roomIdComplete}`;
    navigator.clipboard.writeText(link).catch(err => {console.error('Failed to copy lobby link:', err);});
  }

  createNewLobby(): void {
    const modal = new bootstrap.Modal(document.getElementById('createLobbyModalId'), {});
    modal.show();
  }

  checkPuzzle(): void {
    try {
      (this.$refs.puzzle as Puzzle).checkPuzzle();
    } catch (error) {
      // Ignore error
    }
  }

  checkSquare(): void {
    try {
      (this.$refs.puzzle as Puzzle).checkSelectedCell();
    } catch (error) {
      // Ignore error
    }
  }

  revealSquare(): void {
    try {
      (this.$refs.puzzle as Puzzle).revealSelectedCell();
    } catch (error) {
      // Ignore error
    }
  }

  launchNewLobby(): void {
    const roomMode = this.createRoomCommunityMode ? "community" : "default";
    const newRoomId = generateLobbyName(roomMode, this.createRoomPrivacyMode)
    const link = `https://crosswordrace.com/crossword/live?inviteRoomId=${newRoomId}`;
    window.location.href = link;
  }

  changeRoomPuzzlePreferences(): void {
    const modal = new bootstrap.Modal(document.getElementById('changeRoomPuzzlePreferencesModalId'), {});
    modal.show();
  }

  confirmRoomPuzzlePreferences(): void {
    saveRoomPuzzlePreferencesInLocalStorage(this.roomPuzzlePreferences);
    window.location.reload();
  }

  showRevealModal(): void {
    const modal = new bootstrap.Modal(document.getElementById('revealPuzzleModalId'), {});
    modal.show();
  }

  confirmRevealPuzzle(): void {
    this.isRevealed = true;
    this.stopTimer();
    this.revealGrid();
  }

  get currentUrl(): string {
    return window.location.href;
  }

  get facebookShareLink(): string {
    return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.currentUrl);
  }

  get twitterShareLink(): string {
    return 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(this.currentUrl) + '&text=Check%20this%20out:%20';
  }

  get isPuzzleLocked(): boolean {
    if (this.gameStatus === RaceStatus.IN_PROGRESS) {
      return false;
    } else {
      return true;
    }
  }

  get gameStatus(): RaceStatus {
    // You are waiting to join a lobby
    if (this.isWaitForJoin) {
      return RaceStatus.JOINING;
    }
    // You are waiting for the next game
    if (this.isWaitForNextRound) {
      return RaceStatus.WAITING;
    }
    // You gave up on the puzzle
    if (this.isRevealed) {
      return RaceStatus.REVEALED;
    }
    // Countdown for the next race
    if (this.countdown > 0)  {
      this.resetTimer();
      this.resetPuzzle();
      return RaceStatus.COUNTDOWN;
    }
    // The race is active if the countdown is less than 0 AND the puzzle is not solved
    if (this.countdown <= 0 && !this.isPuzzleSolved) {
      return RaceStatus.IN_PROGRESS;
    }
    // The race is over if the countdown is less than 0 AND the puzzle is solved
    if (this.countdown <= 0 && this.isPuzzleSolved) {
      return RaceStatus.SOLVED;
    }
    return RaceStatus.UNKNOWN;
  }

  get showPuzzleOverlay() {
    if (this.gameStatus === RaceStatus.IN_PROGRESS) {
      return false
    } else {
      return true;
    }
  }

  get crosswordRaceState(): CrosswordRaceSolve | null {
    if (this.crossword && this.gameId) {
      return { 
        "userId": this.userId,
        "username": this.username,
        "puzzleId": this.crossword.puzzleId,
        "gameId": this.gameId,
        "state": (this.$refs.puzzle as Puzzle).grid,
        "isSolved": this.isPuzzleSolved,
        "isWaiting": this.isWaitForNextRound,
        "isRevealed": this.isRevealed,
        "timestamp": getEpochSeconds(),
        "time": this.getTime(),
      }
    }
    return null;
  }

  get isPuzzleSolved(): boolean {
    return (this.$refs.puzzle as Puzzle).isSolved;
  }

  get isLoggedIn(): boolean {
    return store.getters[`${VuexModuleNamespaces.App}/${DataStore.getters.getIsLoggedIn.name}`];
  }

  get roomIdComplete(): string {
    const messageWithRoomId = this.lobbyMessages.find(
      (message) => message.roomId
    );
    return messageWithRoomId ? messageWithRoomId.roomId : "";
  }

  get roomId(): string {
    const messageWithRoomId = this.lobbyMessages.find(
      (message) => message.roomId
    );
    return messageWithRoomId ? messageWithRoomId.roomId.slice(0, -7) : "";
  }

  get playerCount(): number {
    return this.gameMessages.length;
  }

  get username(): string {
    if (this.isLoggedIn) {
      return store.getters[`${VuexModuleNamespaces.App}/${DataStore.getters.getUsername.name}`];
    } else {
      return getAnonymousUsername();
    }
  }

  get userId(): string {
    if (this.isLoggedIn) {
      return store.getters[`${VuexModuleNamespaces.App}/${DataStore.getters.getUserId.name}`];
    } else {
      return getAnonymousUserId();
    }
  }
}
</script>
  
<style scoped>
#crossword-race-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.puzzle-overlay {
  position: relative;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.race-result-container {
  justify-content: center;
  display: flex;
}
.form-check-input:checked {
   background-color: black !important;
   border-color: black !important;
}
#roomIdSelect {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 1.5em;
  background-position: right center;
}
@media (min-width: 500px) {
  #roomIdSelect {
    max-width: 200px;
  }
}
</style>
